import React from 'react';
import segmentImage from '../data/segment_info.png' // Adjust the import path

const SegmentInformation = () => {
    return (
        <div>
            <h2>Advertising Cost by Audience</h2>
            {/* Displaying the imported image */}
            <img
                src={segmentImage}
                alt="Segment Preference Index"
                style={{ width: '40vw', height: 'auto', paddingBottom: '24px'  }}
            />
        </div>
    );
};

export default SegmentInformation;
